import RoundButton from '@components/button/RoundButton'
import { QuizContext } from '@context/QuizContext'
import React, { useContext } from 'react'

const BackButton = () => {
    const { backStep } = useContext(QuizContext)
    return (
        <RoundButton
            onClick={backStep}
            type='button'
            variant='default'
            label='ย้อนกลับ'
        />
    )
}

export default BackButton
